import { IIndexable, IncludedType } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IUsersource, Usersource } from 'utility-ts-datasource';
import { IAppointmentType, IStudentServiceCategory, IStudentServices } from '../types/appointment_interfaces';
import { ILocation, ILocationCourses, IOrganizer } from '../types/appt_interfaces';

export interface IAppointmentLocationsOrganizersUsersourceModel {
  selectedLocation: ILocation;
  selectedOrganizers: IOrganizer[];
  selectedCourse: ILocationCourses;
}

export type TAppointmentLocationsOrganizersUsersource = IUsersource<IAppointmentLocationsOrganizersUsersourceModel>;

export const AppointmentLocationsOrganizersUsersourceFactory: () => TAppointmentLocationsOrganizersUsersource =
  (): TAppointmentLocationsOrganizersUsersource => {
    return new Usersource<IAppointmentLocationsOrganizersUsersourceModel>({
      selectedLocation: {} as ILocation,
      selectedCourse: {} as ILocationCourses,
      selectedOrganizers: [] as IOrganizer[]
    });
  };



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/usersources/appointment_location_staff_usersource.ts